export default __webpack_public_path__ + "static/quick-give-screen-a69d47eb8f85550b2641241d65f909d8.png";